

theme.shoppingControls = (function() {
    var _shoppingControls = {};
    _shoppingControls.$quantity = $('#buy-now-button__wrapper');

    _shoppingControls.getCartItemObject  = function(targetEl) {
        var $control = $(targetEl).closest('[data-quantity-shopping-container]');
        var productId = $control.attr('data-quantity-shopping-container');
        var $qtyInput = $control.find('[data-quantity-input]');
        var $qtyProxy = $control.find('[data-quantity-text]');
        var qty = parseInt($qtyInput.val());
        var stock = parseInt($qtyInput.attr('data-stock'));

        return {
            $control: $control,
            id: productId,
            qty: qty,
            stock: stock,
            $qtyInput: $qtyInput,
            $qtyProxy: $qtyProxy
        }
    }

    _shoppingControls.registerControls = function(){

        _shoppingControls.$quantity.on('click', '[data-quick-shopping-control="sub"]', function(){
            var cartItem = _shoppingControls.getCartItemObject(this);
            var newQty = cartItem.qty - 1 > 0 ? cartItem.qty - 1 : 0;

            cartItem.$qtyInput.val(newQty);
            cartItem.$qtyProxy.html(newQty);

            $(window).trigger('dataLayer-add-update-qnty', newQty);
        });

        _shoppingControls.$quantity.on('click', '[data-quick-shopping-control="add"]', function(){
            var cartItem = _shoppingControls.getCartItemObject(this);
            var newQty = cartItem.qty + 1 <= cartItem.stock ? cartItem.qty + 1 : cartItem.qty;

            cartItem.$qtyInput.val(newQty);
            cartItem.$qtyProxy.html(newQty);

            $(window).trigger('dataLayer-add-update-qnty', newQty);
        });
    };

    _shoppingControls.init = function() {
        if(!_shoppingControls.$quantity.length) {
            console.warn('Cart Error');
            return;
        } else {

            _shoppingControls.registerControls();

        }
    };

    return _shoppingControls;
})();

